import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LinkGen } from "../LinkGen";
import { useVideoAdminCheck } from "../video/useVideoGenerations";
import { VideoCreationCard } from "./VideoCreationCard";

/** Story 5.3: Settings → Video, where the account's video defaults live. */
export const TabVideo = () => {
	const adminCheck = useVideoAdminCheck();
	return (
		<>
			<h2 className="mb-2">Video</h2>
			<p className="text-muted mb-4">
				Pick the presenter, voice and style Moxie uses for new videos, and set
				your own credit budget so you get a warning before HeyGen spend runs
				high. Your first video saves presenter choices here automatically.
			</p>
			<Row>
				<Col md={6} lg={5}>
					<VideoCreationCard />
					{adminCheck.data?.isAdmin && (
						<div className="mt-3">
							<Link to={LinkGen.Settings.VideoAdmin()}>
								View failed videos and cost by account (admin)
							</Link>
						</div>
					)}
				</Col>
			</Row>
		</>
	);
};
